<template>
  <hlt-text
    class="asset-page-footer-meta-component"
    :size="'sm'"
    :variant="'content-secondary'"
  >
    <template v-if="formattedViews">
      {{ formattedViews.toLocaleString() }} Views &middot;
    </template>{{ asset.createdAtText }}
  </hlt-text>
</template>

<script>
import HltText from '@/components/ui/text.vue';

export default {
  components: {HltText},
  props: {
    asset: {
      type: Object,
    },
    totalViews: {
      type: Number,
    },
  },
  computed: {
    formattedViews() {
      if (this.totalViews) {
        const numified = Number(this.totalViews);
        if (isNaN(numified)) {
          return '0';
        } else {
          return numified.toLocaleString();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-page-footer-meta-component {
  text-align: center;
}
</style>
